// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2Nxxl","label":"Section_label__1G_Wq","contentWrap":"Section_contentWrap__ARalo","footer":"Section_footer__2FVJh","footerInner":"Section_footerInner__2JjH8"};